import { render, staticRenderFns } from "./VentasMercadoPagoNoIngresadas.vue?vue&type=template&id=0483a11e&"
import script from "./VentasMercadoPagoNoIngresadas.vue?vue&type=script&lang=js&"
export * from "./VentasMercadoPagoNoIngresadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports